"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.StatusDescription = exports.CaseStatus = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var DefaultGroupedCases = {
    groupType: 'none',
    caseRuns: []
};
var DEFAULT_PROPS = {
    groupedCases: __assign({}, DefaultGroupedCases),
    secondaryPrefix: '',
    isPreGoLive: false,
    secondaryIndicatorVisibility: true
};
var getMiniStatus = function (caseRun) {
    var _a, _b;
    var statusDisplay = ui_common_1.caseUtils.deriveStatus(caseRun);
    // TODO: CDS does not currently support exam_description
    // const description = caseRun.exam_description ?? '';
    var clinicalId = "".concat(caseRun.primary_clinical_identifier.number, " (").concat(caseRun.primary_clinical_identifier.issuer, ")");
    var caseType = caseRun.case_type ? "- ".concat(caseRun.case_type) : '';
    var styleClasses = [
        'related-group-item',
        'qa-related-group-item',
        statusDisplay.styleClass
    ];
    return ((0, jsx_runtime_1.jsx)("li", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ className: "qa-related-group-item-link", href: "/cmx/cases/".concat(((_a = caseRun.case_uid) === null || _a === void 0 ? void 0 : _a.length) > 0 ? caseRun.case_uid : caseRun.case_id), "data-case-id": "".concat(((_b = caseRun.case_uid) === null || _b === void 0 ? void 0 : _b.length) > 0 ? caseRun.case_uid : caseRun.case_id), title: "".concat(caseRun.exam_description) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "info-display" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "circle" }), statusDisplay.signifier] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "descriptive-text ellipsify" }, { children: "".concat(caseRun.exam_description) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "clinical-id sensitive-data" }, { children: ["#", clinicalId] }))] })) }), caseRun.process_instance_id));
};
var getBillingGroup = function (groupedCases) {
    var caseRuns = groupedCases.caseRuns;
    if (!caseRuns || !caseRuns.length) {
        return false;
    }
    var relatedStatuses = caseRuns.map(getMiniStatus);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "relation-grouping" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "relation-grouping-reason" }, { children: "Billed with:" })), (0, jsx_runtime_1.jsx)("ul", __assign({ className: "related-group" }, { children: relatedStatuses }))] })));
};
var StatusDescription = function (props) {
    var computed = __assign(__assign({}, DEFAULT_PROPS), props);
    var caseDetail = computed.caseRun, secondaryPrefix = computed.secondaryPrefix, passedPreGoLive = computed.isPreGoLive, groupedCases = computed.groupedCases, secondaryIndicatorVisibility = computed.secondaryIndicatorVisibility, includeBox = computed.includeBox, rest = __rest(computed, ["caseRun", "secondaryPrefix", "isPreGoLive", "groupedCases", "secondaryIndicatorVisibility", "includeBox"]);
    var isPreGoLive = passedPreGoLive || ui_common_1.caseUtils.isPreGoLive(caseDetail);
    var statusDisplay = ui_common_1.caseUtils.deriveStatus(caseDetail);
    var statusSignifier = statusDisplay.signifier;
    var secondaryIndicatorText = ui_common_1.caseUtils.getStatusReason(caseDetail);
    var classes = [
        props.className,
        'standalone-status',
        'description',
        statusDisplay.styleClass
    ];
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: includeBox && secondaryIndicatorText ? 'status-description' : '' }, { children: (0, jsx_runtime_1.jsxs)("span", __assign({}, rest, { className: (0, classnames_1["default"])(classes) }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "status-signifier" }, { children: statusSignifier })), isPreGoLive && includeBox !== true && ((0, jsx_runtime_1.jsx)("span", __assign({ className: "status-modifier" }, { children: "Pre Go-Live" }))), secondaryIndicatorVisibility && secondaryIndicatorText && ((0, jsx_runtime_1.jsx)("span", __assign({ className: "secondary-indicator-text" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "secondary-indicator" }, { children: secondaryIndicatorText })) })))] })) })));
};
exports.StatusDescription = StatusDescription;
StatusDescription.displayName = 'StatusDescription';
var CaseStatus = function (props) {
    var computed = __assign(__assign({}, DEFAULT_PROPS), props);
    var caseDetail = computed.caseRun, timeStamp = computed.timeStamp, isPreGoLive = computed.isPreGoLive, groupedCases = computed.groupedCases, secondaryPrefix = computed.secondaryPrefix, billingGroupLoadState = computed.billingGroupLoadState, includeBox = computed.includeBox, rest = __rest(computed, ["caseRun", "timeStamp", "isPreGoLive", "groupedCases", "secondaryPrefix", "billingGroupLoadState", "includeBox"]);
    var statusDisplay = ui_common_1.caseUtils.deriveStatus(caseDetail);
    var showLoading = billingGroupLoadState !== null && (billingGroupLoadState === null || billingGroupLoadState === void 0 ? void 0 : billingGroupLoadState.initial);
    var readout = ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "large-info-display" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "col-code" }, { children: (0, jsx_runtime_1.jsx)("span", { className: "large-circle" }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "description-container" }, { children: [(0, jsx_runtime_1.jsx)(StatusDescription, { caseRun: caseDetail, isPreGoLive: isPreGoLive, includeBox: true }), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "description-timestamp" }, { children: ["Updated ", timeStamp, " "] })), showLoading && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "billing-group-loading-message relation-grouping" }, { children: "Checking for other billed exams..." }))), getBillingGroup(groupedCases)] }))] })));
    var classes = [props.className, 'case-status', statusDisplay.styleClass];
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, rest, { className: (0, classnames_1["default"])(classes) }, { children: readout })));
};
exports.CaseStatus = CaseStatus;
CaseStatus.displayName = 'CaseStatus';
//# sourceMappingURL=case-status.js.map